import React from "react";
import TempleThreshholds from "./TempleThreshholds";
import TemplePillars from "./TemplePillars";
import LightStatue from "./LightStatue";
import ZeuslangStatue from "./ZeuslangStatue";
import TempleGridStatue from "./TempleGridStatue";

const Temple = () => {
  return (
    <div>
      <TempleThreshholds />
      <TemplePillars />

      <div>
        <ZeuslangStatue />
        <TempleGridStatue />
        <LightStatue />
      </div>
    </div>
  );
};

export default Temple;
